(function($) {
  function AutoplayToggle( value ) {
    $.post( Autoplay.ajax_url, {
      'action' : 'toggle_autoplay',
      'nonce' : Autoplay.nonce,
      'topic_id' : Autoplay.topic_id,
      'user_id' : Autoplay.user_id,
      'key' : Autoplay.key,
      'value' : value
    }, 'json')
    .done(function(response, textStatus, jqXHR){
      console.log("autoplay toggle response", response );
      
    })
    .fail(function( jqXHR, textStatus, errorThrown ) { console.log('fail', errorThrown); });
  }

  //toggle user response
  $("input#autoplay").change(function(e) {
    new AutoplayToggle( $(this).is(":checked") );
  });

})(jQuery); // Fully reference jQuery after this point.